import Keycloak from 'keycloak-js'
import { ApiObterUserInfoNc } from '@/api'
import router from '@/router'
import { AUTORIZAR, CARREGAR_INFOS, OBTER_ACESSOS, PERMITIDO, SET_USER, USER_INFO } from './mutations-type'
import { GetAuthAlternativo } from '@/localStorage'
import { useKeycloak } from '@/composables/useKeycloak'

const { init } = useKeycloak()
export const ActionAutenticarContaKeycloak = async ({ dispatch, commit }) => {
  return new Promise(async (resolve, reject) => {
    const keycloak = new Keycloak({
      realm: `${process.env.VUE_APP_REALM}`,
      clientId: 'mrs_client',
      url: `${process.env.VUE_APP_AUTH}`
    })
    
    if (window.location.href.indexOf('nao-autorizado') == -1 && GetAuthAlternativo().email == null) {
      await init()
    }

    dispatch('ActionObterUserInfoMain').then((response) => commit('setUser', response))

    resolve()
  })
}

export const ActionObterUserInfoMain = async ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    await ApiObterUserInfoNc().then(async (response) => {
      const userInfo = response

      if (userInfo == null || !userInfo.ativo) {        
        await router.push('/nao-autorizado')
      } else {
        await router.push('/home')
      }

      commit(USER_INFO, userInfo)

      resolve(userInfo)
    })
  })
}

export const ActionObterUserInfo = async ({ commit }) =>
  await ApiObterUserInfoNc()
    .then((response) => commit(USER_INFO, response))
    .catch(() => commit(USER_INFO, null))

export const ActionAutorizar = async ({ commit }) => commit(AUTORIZAR)

export const ActionPermitido = async ({ commit }, recurso) => commit(PERMITIDO, recurso)

//XGH: Analisar
// export const ActionCarregarInfos = async ({ commit }, store) => {  
//   commit(OBTER_ACESSOS)
//   commit(CARREGAR_INFOS, store)
// }

export const getUser = async ({ commit }, payload) => commit(SET_USER, payload)
